export default function AboutIntro() {
  return (
    <section className="bg-white py-20 md:py-24 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
          
          {/* Text */}
          <div>
            <span className="mb-3 inline-block text-sm font-semibold text-green-600">
              قصتنا
            </span>

            <h2 className="text-3xl font-bold leading-tight text-gray-900 md:text-4xl">
              نؤمن أن المخلفات يمكن أن تصبح موارد
            </h2>

            <div className="mt-6 space-y-4 text-gray-600">
              <p className="leading-8">
                في خبراء التدوير نعمل على تقديم حلول متخصصة في مجال إعادة
                التدوير وإدارة المواد القابلة للاستفادة، من خلال عمليات
                منظمة تبدأ من الجمع والاستلام وتنتهي بإعادة توجيه المواد
                للاستفادة منها من جديد.
              </p>

              <p className="leading-8">
                نسعى إلى بناء نموذج أكثر كفاءة واستدامة يساعد الأفراد
                والمنشآت على التعامل مع المواد القابلة لإعادة التدوير
                بطريقة احترافية ومسؤولة.
              </p>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="overflow-hidden rounded-3xl">
              <img
                src="/images/about/about-main.jpg"
                alt="خبراء التدوير"
                className="h-[420px] w-full object-cover"
              />
            </div>

            <div className="absolute -bottom-6 -right-6 hidden rounded-2xl bg-green-600 px-6 py-5 text-white shadow-xl sm:block">
              <p className="text-2xl font-bold">استدامة</p>
              <p className="mt-1 text-sm text-green-100">
                تبدأ بخطوة
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}